import { CollapsedMode, ContextMode } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { useCallback, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useApplicationContext } from '../../../modules/context/ApplicationContext/ApplicationContext';
import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../stores/AppEnvironment/appEnvironment.store.selectors';
import PATHS from '../../routes.const';
import { useSubNavContext } from './useSubNavContext';

export const useAppTemplateMode = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const { isStore, state } = useApplicationContext();
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);

  const hasUser = !!state.user;
  const isSubContext = !!useSubNavContext(pathname);

  const contextMode: ContextMode = isSubContext ? 'nested' : 'root';
  const collapsedMode: CollapsedMode = isStore && isInStoreEnvironment ? 'rail' : 'hidden';

  const lastMainRoute = useRef(PATHS.main.home.path);
  useEffect(() => {
    if (!isSubContext && hasUser) {
      lastMainRoute.current = pathname;
    }
  }, [pathname, isSubContext, hasUser]);

  const onBack = useCallback(() => {
    history.push(lastMainRoute.current);
  }, [history]);

  return { contextMode, collapsedMode, onBack };
};
